import { render } from "./Odontogram.vue?vue&type=template&id=4550221f&scoped=true"
import script from "./Odontogram.vue?vue&type=script&lang=js"
export * from "./Odontogram.vue?vue&type=script&lang=js"

import "./Odontogram.vue?vue&type=style&index=0&id=4550221f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4550221f"]])

export default __exports__